import axios from 'axios'
import * as vars from './vars';

export function getAllNotifications (jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/messaging/GetUserNotifications',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: {state: 'unread'}
    })
}

export function markNotificationRead (notificationId, jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/messaging/MarkNotificationsRead',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : { notificationId: notificationId }
    })
}

export function markThreadNotificationRead (threadId, jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/messaging/MarkNotificationsRead',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : { threadId: threadId }
    })
}

export function registerDeviceToken (deviceId, token, platform, jwt) {
  const environment = ['localhost', '127.0.0.1'].includes(window.location.hostname) ? "DEVELOPMENT" : "PRODUCTION";
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/messaging/RegisterDeviceNotificationToken',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : {
          platform: platform,
          environment: environment,
          token: token,
          deviceId: deviceId
        }
    })
}

export function unRegisterDeviceToken (endpoint, platform, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/messaging/UnregisterDeviceNotificationToken',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : {
          platform: platform,
          token: endpoint
        }
    })
}
